<template>
    <div class="generic-modal-container" v-if="!hidden" :class="{
        opened: !hidden,
        'bg-clip-padding bg-gray-50 backdrop-filter backdrop-blur-md bg-opacity-60': !hidden,
        opaque: isOpaque
    }">
        <div class="generic-modal" :class="{smaller: smaller, larger: larger, medium: medium}">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['name','isOpaque', 'smaller', 'larger', 'medium'],
        data() {
            return {
                hidden: true
            }
        },
        computed: {},
        methods: {
            closeModal() {
                this.hidden = true;
            },
            openModal() {
                this.hidden = false;
            }
        },
        mounted() {
            var that = this;
            var key = '';
            if (this.name) {
                key = '-' + this.name;
            }
            eventBus.$on('modal-open' + key, function (closure) {
                that.openModal();
            });
            eventBus.$on('modal-close' + key, function (closure) {
                that.closeModal();
            });
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/setup';

    .generic-modal-container {
        display: none;
        &.opened {

            position: absolute;
            min-height: 100vh;
            width: 100vw;
            z-index: 100000;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            top: 0;
            left: 0;
            padding: 2em;
            @include desktop() {

              &.opaque {
                background-color: rgba(255, 255, 255, 1);
              }
            }
        }
    }

    .generic-modal {
        padding: 1em;
        @include grid-column(12);
        @include clearfix();
        @include desktop() {
          background-color: #fff;
          border-radius: 0.5em;
          box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
          @include grid-column(5);
          &.smaller {
            @include grid-column(3);
          }
          &.medium{
            @include grid-column(5);
            min-width: 950px;
            max-width: 100%;
          }
          &.larger {
            @include grid-column(8);
          }
          padding: 2em;
        }

        div.actions {
            text-align: left;
            margin-top: 30px;
            a, input[type="submit"] {
                padding: 0.7em 0.7em 0.8em;
                text-decoration: none;
                color: #fff;
                border-radius: $standardBorderRadius;
            }
            input[type="submit"] {
                background-color: $green;
            }
            a {
                background-color: #999;
            }
            a.success{
                background-color: $green;
            }
            @include desktop() {
                float: right;
                text-align: right;
            }
        }
    }
</style>
